const LOCALHOST_NAME = "localhost";
const LOOPBACK_IPV4_HOST = ["127", "0", "0", "1"].join(".");
const UNSPECIFIED_IPV4_HOST = Array(4).fill("0").join(".");
const LOOPBACK_IPV6_HOST = `${":".repeat(2)}1`;
const BRACKETED_LOOPBACK_IPV6_HOST = `[${LOOPBACK_IPV6_HOST}]`;

const LOCAL_HOSTS = new Set([
  LOCALHOST_NAME,
  LOOPBACK_IPV4_HOST,
  UNSPECIFIED_IPV4_HOST,
  LOOPBACK_IPV6_HOST,
  BRACKETED_LOOPBACK_IPV6_HOST,
]);

export const isLocalHostname = (hostname?: string | null) => {
  const value =
    hostname ?? (typeof window !== "undefined" ? window.location.hostname : "");
  return LOCAL_HOSTS.has(value.toLowerCase());
};
